import { ReactNode } from 'react';
import { Divider, Typography, useTheme } from '@mui/material';

export interface IMplDividerProps {
	message?: ReactNode;
}

export function MplDivider({ message }: IMplDividerProps) {
	const theme = useTheme();
	return (
		<Divider
			sx={{
				'&::before, &::after': {
					borderColor: theme.palette.solutions?.[200],
				},
				...(message && {
					'& .MuiDivider-wrapper': {
						paddingLeft: '24px',
						paddingRight: '24px',
					},
				}),
			}}
		>
			{message && (
				<Typography variant="l1" color={theme.palette.solutions?.[800]}>
					{message}
				</Typography>
			)}
		</Divider>
	);
}
